// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lead-collector-success[data-v-3722695e]{align-items:center;display:flex;flex-direction:column;grid-gap:var(--unit-0400);gap:var(--unit-0400);padding:var(--unit-0600)}.lead-collector-success__title[data-v-3722695e]{text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
